// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2blFb","toggle":"styles_toggle__An2V-","preview":"styles_preview__Ab3F_"};